import type { ComponentsTranslations } from './components.translations.pl.ts';
import { processTimerTranslations } from './processTimer/processTimer.translation.fr.ts';
import { tableTranslations } from './table/table.translations.fr.ts';

export const componentsTranslations: ComponentsTranslations = {
  table: tableTranslations,
  loader: {
    loading: 'Chargement...',
  },
  narrator: {
    disable: 'Désactiver le narrateur',
    enable: 'Activer le narrateur',
  },
  processTimer: processTimerTranslations,
  slider: {
    ariaLabel: "Choisis une valeur sur l'échelle",
  },
  textArea: {
    characterCount: '{{current}}/{{max}} caractères',
  },
};
